import * as angular from "angular";
import {IController} from "angular";
import {ServicesService} from "../../services/services-service.service";

export class serviceTimelineLogsViewCtrl implements IController {
  service: any;

  private timeline;

  constructor(private servicesService: ServicesService) {
  }

  $onInit() {
    this._getLogsTimeline();
  }

  $onChanges(changes) {
    if (changes.service && !changes.service.isFirstChange()) {
      this._getLogsTimeline();
    }
  }

  private _getLogsTimeline() {
    if (this.service) {
      this.servicesService.getLogsTimeline(this.service.id)
        .then((timeline) => {
          this.timeline = timeline;
        })
    }
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceTimelineLogsView', {
    bindings: {
      service: '<'
    },
    template: require('./service-timeline-logs-view.html').default,
    controller: serviceTimelineLogsViewCtrl
  });
